const chip = {
  label1: 'none selected',
  label2: 'selected(s)',
  Typography: 'select all'
}

export default chip;
